import { call, put, takeLatest } from "redux-saga/effects";
import {
  markAnswerSuccess,
  markAnswerFailure,
  markAnswerStart,
} from "../reducer";
import { httpMarkAnswer } from "../../../services/generate";
import { networkErrorHandler } from "../../../utils/errorHandlers";

function* markAnswer({ payload }) {
  const response = yield call(httpMarkAnswer, payload);

  const { success, raw, message } = response;
  if (success) {
    yield put(markAnswerSuccess(raw));
  } else {
    yield put(markAnswerFailure(message || raw?.error));
    networkErrorHandler(response.statusCode, message || raw?.error);
  }
}

export default function* onMarkAnswer() {
  yield takeLatest(markAnswerStart, markAnswer);
}
